/* ═══════════════════════════════════════════════════════════════
   CIPRIAN — Cart Drawer + Wishlist
   ═══════════════════════════════════════════════════════════════ */

/* ── Helpers ─────────────────────────────────────────────────── */
function fmt(cents) {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency', currency: 'MXN', minimumFractionDigits: 2
  }).format(cents / 100);
}

/* ══════════════════════════════════════════════════════════════
   CART DRAWER
══════════════════════════════════════════════════════════════ */

/* Umbral de envío gratis: $999 MXN = 99900 centavos */
var FREE_SHIPPING_THRESHOLD = 125000;

var CartDrawer = {
  el:          null,
  overlay:     null,
  body:        null,
  footer:      null,
  shippingBar: null,
  upsellEl:    null,

  init: function () {
    this.el          = document.getElementById('cartDrawer');
    this.overlay     = document.getElementById('cartDrawerOverlay');
    this.body        = document.getElementById('cartDrawerBody');
    this.footer      = document.getElementById('cartDrawerFooter');
    this.shippingBar = document.getElementById('cartShippingBar');
    this.upsellEl    = document.getElementById('cartUpsell');
    this.step1       = document.getElementById('cartStep1');
    this.step2       = document.getElementById('cartStep2');
    this.titleEl     = document.getElementById('cartDrawerTitle');
    this.backBtn     = document.getElementById('cartBackBtn');
    if (!this.el) return;

    /* back button */
    if (this.backBtn) {
      this.backBtn.addEventListener('click', function () { CartDrawer.goToStep(1); });
    }

    /* auto-save form fields on blur */
    var fields = ['dafEmail','dafFirst','dafLast','dafAddress','dafAddress2',
                  'dafZip','dafCity','dafState','dafPhone'];
    fields.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('change', function() { CartDrawer.saveFormData(); });
    });

    /* toggle factura info */
    var facturaCb = document.getElementById('dafFactura');
    var facturaInfo = document.getElementById('dafFacturaInfo');
    if (facturaCb && facturaInfo) {
      facturaCb.addEventListener('change', function() {
        facturaInfo.classList.toggle('is-open', facturaCb.checked);
      });
    }

    /* toggle newsletter info */
    var newsletterCb = document.getElementById('dafNewsletter');
    var newsletterInfo = document.getElementById('dafNewsletterInfo');
    if (newsletterCb && newsletterInfo) {
      newsletterCb.addEventListener('change', function() {
        newsletterInfo.classList.toggle('is-open', newsletterCb.checked);
      });
    }

    /* copy discount code */
    var copyBtn = document.getElementById('dafCopyBtn');
    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        var code = (document.getElementById('dafCodeText') || {}).textContent || 'BIENVENIDO15';
        navigator.clipboard && navigator.clipboard.writeText(code).then(function() {
          copyBtn.innerHTML = '✓ Copiado';
          setTimeout(function() {
            copyBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/></svg> Copiar';
          }, 2000);
        });
      });
    }

    /* shipping form submit */
    var dafForm = document.getElementById('drawerShippingForm');
    if (dafForm) {
      dafForm.addEventListener('submit', function (e) {
        e.preventDefault();
        CartDrawer.submitShippingForm();
      });
    }

    /* open on cart icon click */
    document.querySelectorAll('[data-open-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        CartDrawer.open();
      });
    });

    /* close buttons */
    document.querySelectorAll('[data-close-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () { CartDrawer.close(); });
    });

    /* close on overlay */
    this.overlay && this.overlay.addEventListener('click', function () {
      CartDrawer.close();
    });

    /* ESC key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') CartDrawer.close();
    });
  },

  open: function () {
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    this.fetch();
  },

  close: function () {
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  },

  fetch: function () {
    this.body.innerHTML = '<div class="cart-loading"><span class="cart-spinner"></span></div>';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { CartDrawer.render(cart); })
      .catch(function () {
        CartDrawer.body.innerHTML = '<p style="padding:24px;color:#888;">Error al cargar el carrito.</p>';
      });
  },

  render: function (cart) {
    /* ── Shipping bar (always update) ── */
    this.renderShippingBar(cart.total_price, cart.item_count);

    /* ── Promos bundle ── */
    CartPromos.render(cart);

    /* ── Empty state ── */
    if (cart.item_count === 0) {
      this.body.innerHTML =
        '<div class="cart-empty">' +
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="48" height="48" style="opacity:.25;margin-bottom:16px;">' +
            '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-1.35 2.7A1 1 0 007 17h10M7 13L5.4 5M17 17a2 2 0 100 4 2 2 0 000-4zm-10 0a2 2 0 100 4 2 2 0 000-4z"/>' +
          '</svg>' +
          '<p class="cart-empty-text">Tu carrito está vacío</p>' +
          '<a href="/collections/all" class="btn-checkout" onclick="CartDrawer.close()">Ver productos</a>' +
        '</div>';
      this.footer.innerHTML = '';
      if (this.upsellEl) this.upsellEl.innerHTML = '';
      return;
    }

    /* ── Items ── */
    var html = '<ul class="cart-items">';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? (item.image.split('?')[0] + '?width=120') : '';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-item-variant">' + item.variant_title + '</p>' : '';
      /* Descuento por item — usa original_line_price vs final_line_price */
      var origLine  = item.original_line_price;
      var finalLine = item.final_line_price;
      var itemSaved = origLine - finalLine;
      var priceHtml = itemSaved > 0
        ? '<div class="cart-item-price-wrap">' +
            '<s class="cart-item-orig-price">' + fmt(origLine) + '</s>' +
            '<span class="cart-item-price cart-item-price--sale">' + fmt(finalLine) + '</span>' +
          '</div>'
        : '<span class="cart-item-price">' + fmt(finalLine) + '</span>';
      var discountBadge = itemSaved > 0
        ? '<span class="cart-item-disc-badge">🔥 Descuento aplicado</span>'
        : '';
      html +=
        '<li class="cart-item">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" class="cart-item-img" loading="lazy">' : '') +
          '<div class="cart-item-info">' +
            '<p class="cart-item-title">' + item.product_title + '</p>' +
            variant +
            discountBadge +
            '<div class="cart-item-bottom">' +
              '<div class="cart-qty-ctrl">' +
                '<button class="qty-sm" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '">−</button>' +
                '<span class="qty-sm-val">' + item.quantity + '</span>' +
                '<button class="qty-sm" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
              '</div>' +
              priceHtml +
            '</div>' +
          '</div>' +
          '<button class="cart-remove" data-key="' + item.key + '" aria-label="Eliminar">✕</button>' +
        '</li>';
    });
    html += '</ul>';
    this.body.innerHTML = html;

    /* ── Footer ── */
    /* Usar original_total_price de Shopify (incluye descuentos automáticos) */
    var originalTotal = cart.original_total_price;
    var savings = Math.max(0, originalTotal - cart.total_price);
    var hasSavings = savings > 0;

    var subtotalHtml = hasSavings
      ? '<div class="cart-price-breakdown">' +
          '<div class="cart-total-row cart-total-row--original">' +
            '<span>Total sin descuento</span>' +
            '<s class="cart-compare-price">' + fmt(originalTotal) + '</s>' +
          '</div>' +
          '<div class="cart-total-row cart-total-row--final">' +
            '<span>Total</span>' +
            '<strong class="cart-final-price">' + fmt(cart.total_price) + '</strong>' +
          '</div>' +
        '</div>' +
        '<div class="cart-savings-badge">' +
          '<span class="csb-star">🎉</span>' +
          ' ¡Ahorras <strong>' + fmt(savings) + '</strong> en esta compra!' +
        '</div>'
      : '<div class="cart-subtotal">' +
          '<span>Subtotal (' + cart.item_count + ' art.)</span>' +
          '<strong>' + fmt(cart.total_price) + '</strong>' +
        '</div>';

    this.footer.innerHTML = subtotalHtml +
      '<div class="cart-mini-extras">' +
        '<label class="cme-row">' +
          '<input type="checkbox" id="cmeFactura" class="cme-check">' +
          '<span>Requiero factura electrónica (CFDI)</span>' +
        '</label>' +
        '<label class="cme-row">' +
          '<input type="checkbox" id="cmeNewsletter" class="cme-check">' +
          '<span>Suscribirme y recibir <strong>15% de descuento</strong> en mi próxima compra</span>' +
        '</label>' +
      '</div>' +
      '<button type="button" class="btn-checkout" id="btnOpenPreview">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="15" height="15" style="flex-shrink:0"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>' +
        '<span class="btn-checkout-text">Ir a Pago Seguro</span>' +
      '</button>' +
      '<a href="/cart" class="btn-view-cart">Ver carrito completo</a>' +
      '<div class="cart-footer-trust">' +
        '<div class="cft-badges">' +
          (function() {
            var ic = window.CIPRIAN_PAY_ICONS || {};
            return [
              ['visa','Visa'], ['mastercard','MC'], ['amex','Amex'],
              ['paypal','PayPal'], ['mercadopago','MP'], ['oxxo','OXXO']
            ].filter(function(p){ return ic[p[0]]; })
             .map(function(p){ return '<img src="'+ic[p[0]]+'" alt="'+p[1]+'" class="cft-pay-icon">'; })
             .join('');
          })() +
        '</div>' +
        '<div class="cft-info">' +
          '<span>🚚 Envío gratis desde $1,250</span>' +
          '<span>↩ Devoluciones sin costo · 30 días</span>' +
        '</div>' +
      '</div>';

    /* ── Upsell ── */
    var cartProductIds = cart.items.map(function(i) { return i.product_id; });
    this.fetchUpsell(cartProductIds);

    /* ── Events ── */
    this.body.querySelectorAll('.cart-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        CartDrawer.changeQty(btn.dataset.key, 0);
      });
    });

    this.body.querySelectorAll('.qty-sm').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.dataset.qty, 10);
        var newQty = btn.dataset.action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        CartDrawer.changeQty(btn.dataset.key, newQty);
      });
    });

    /* Ir a Pago Seguro → guarda atributos y va directo al checkout */
    var previewBtn = document.getElementById('btnOpenPreview');
    if (previewBtn) {
      previewBtn.addEventListener('click', function () {
        var facturaEl = document.getElementById('cmeFactura');
        var newsEl    = document.getElementById('cmeNewsletter');
        var factChecked = facturaEl ? facturaEl.checked : false;
        var newsChecked = newsEl    ? newsEl.checked    : false;
        previewBtn.innerHTML = '<span style="opacity:.7">Procesando...</span>';
        previewBtn.disabled = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Requiere factura':       factChecked ? 'Sí' : 'No',
              'Suscripción newsletter': newsChecked ? 'Sí — código: BIENVENIDO15' : 'No'
            }
          })
        }).then(function () {
          var url = '/checkout';
          if (newsChecked) url += '?buyer_accepts_marketing=1';
          window.location.href = url;
        }).catch(function () {
          window.location.href = '/checkout';
        });
      });
    }
  },

  /* ── Step navigation ────────────────────────────────────────── */
  goToStep: function (n) {
    var s1    = this.step1;
    var s2    = this.step2;
    var title = this.titleEl;
    var back  = this.backBtn;

    if (n === 2) {
      if (s1) s1.classList.add('step-exit');
      if (s2) s2.classList.add('step-enter');
      if (back)  back.style.display = 'flex';
      if (title) {
        title.classList.add('is-transitioning');
        setTimeout(function () {
          title.textContent = 'Datos de envío';
          title.classList.remove('is-transitioning');
        }, 200);
      }
      this.loadFormData();
    } else {
      if (s2) s2.classList.remove('step-enter');
      if (s1) s1.classList.remove('step-exit');
      if (back)  back.style.display = 'none';
      if (title) {
        title.classList.add('is-transitioning');
        setTimeout(function () {
          title.textContent = 'Tu Selección';
          title.classList.remove('is-transitioning');
        }, 200);
      }
    }
  },

  saveFormData: function () {
    var g = function (id) { return (document.getElementById(id) || {}).value || ''; };
    try {
      localStorage.setItem('cip_daf', JSON.stringify({
        email:    g('dafEmail'),
        first:    g('dafFirst'),
        last:     g('dafLast'),
        addr1:    g('dafAddress'),
        addr2:    g('dafAddress2'),
        zip:      g('dafZip'),
        city:     g('dafCity'),
        province: g('dafState'),
        phone:    g('dafPhone')
      }));
    } catch (e) {}
  },

  loadFormData: function () {
    try {
      var d = JSON.parse(localStorage.getItem('cip_daf') || 'null');
      if (!d) return;
      var set = function (id, val) {
        var el = document.getElementById(id);
        if (el && val) el.value = val;
      };
      set('dafEmail',   d.email);
      set('dafFirst',   d.first);
      set('dafLast',    d.last);
      set('dafAddress', d.addr1);
      set('dafAddress2',d.addr2);
      set('dafZip',     d.zip);
      set('dafCity',    d.city);
      set('dafState',   d.province);
      set('dafPhone',   d.phone);
    } catch (e) {}
  },

  submitShippingForm: function () {
    var get = function(id){ return (document.getElementById(id) || {}).value || ''; };
    var email    = get('dafEmail').trim();
    var first    = get('dafFirst').trim();
    var last     = get('dafLast').trim();
    var addr1    = get('dafAddress').trim();
    var addr2    = get('dafAddress2').trim();
    var zip      = get('dafZip').trim();
    var city     = get('dafCity').trim();
    var province = get('dafState').trim();
    var phone    = get('dafPhone').trim();
    var errEl    = document.getElementById('dafError');
    var btn      = document.getElementById('dafSubmit');

    /* ── Validación ── */
    var missing = [];
    if (!email || !/\S+@\S+\.\S+/.test(email)) missing.push('correo electrónico válido');
    if (!first)    missing.push('nombre');
    if (!last)     missing.push('apellidos');
    if (!addr1)    missing.push('dirección');
    if (!zip || zip.length < 4) missing.push('código postal');
    if (!city)     missing.push('ciudad');
    if (!province) missing.push('estado');

    if (missing.length) {
      errEl.textContent = 'Por favor ingresa: ' + missing.join(', ') + '.';
      errEl.style.display = 'block';
      return;
    }
    errEl.style.display = 'none';

    /* ── Guardar en localStorage ── */
    try {
      localStorage.setItem('cip_daf', JSON.stringify({
        email:email, first:first, last:last, addr1:addr1,
        addr2:addr2, zip:zip, city:city, province:province, phone:phone
      }));
    } catch(e) {}

    /* ── Guardar factura y newsletter en atributos del carrito ── */
    var facturaChecked   = (document.getElementById('dafFactura')   || {}).checked || false;
    var newsletterChecked = (document.getElementById('dafNewsletter') || {}).checked || false;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Requiere factura': facturaChecked ? 'Sí' : 'No',
          'Suscripción newsletter': newsletterChecked ? 'Sí — código: BIENVENIDO15' : 'No'
        }
      })
    });

    /* ── Feedback ── */
    if (btn) { btn.innerHTML = '<span style="opacity:.7">Procesando...</span>'; btn.disabled = true; }

    var sfToken = window.CIPRIAN_SF_TOKEN || '';
    var store   = window.CIPRIAN_STORE   || window.location.hostname;

    /* Si no hay Storefront token → fallback a URL pre-llenada */
    if (!sfToken) {
      var p = encodeURIComponent;
      window.location.href = '/checkout?' +
        'checkout[email]='                              + p(email)    +
        '&checkout[shipping_address][first_name]='      + p(first)    +
        '&checkout[shipping_address][last_name]='       + p(last)     +
        '&checkout[shipping_address][address1]='        + p(addr1)    +
        '&checkout[shipping_address][address2]='        + p(addr2)    +
        '&checkout[shipping_address][city]='            + p(city)     +
        '&checkout[shipping_address][province]='        + p(province) +
        '&checkout[shipping_address][zip]='             + p(zip)      +
        '&checkout[shipping_address][country]=Mexico'   +
        (phone ? '&checkout[shipping_address][phone]=' + p(phone) : '') +
        (newsletterChecked ? '&checkout[buyer_accepts_marketing]=1' : '');
      return;
    }

    /* ── Storefront API: crear checkout con dirección pre-cargada ── */
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart) {
        var lineItems = cart.items.map(function(i){
          return '{ variantId: "gid://shopify/ProductVariant/' + i.variant_id + '", quantity: ' + i.quantity + ' }';
        }).join(',');

        var mutation = `
          mutation {
            checkoutCreate(input: {
              email: "${email.replace(/"/g,'\\"')}",
              lineItems: [${lineItems}],
              shippingAddress: {
                firstName:  "${first.replace(/"/g,'\\"')}",
                lastName:   "${last.replace(/"/g,'\\"')}",
                address1:   "${addr1.replace(/"/g,'\\"')}",
                address2:   "${addr2.replace(/"/g,'\\"')}",
                city:       "${city.replace(/"/g,'\\"')}",
                province:   "${province.replace(/"/g,'\\"')}",
                zip:        "${zip.replace(/"/g,'\\"')}",
                country:    "Mexico",
                phone:      "${phone.replace(/"/g,'\\"')}"
              }
            }) {
              checkout { id webUrl availableShippingRates { ready shippingRates { handle title } } }
              checkoutUserErrors { message }
            }
          }`;

        return fetch('https://' + store + '/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': sfToken
          },
          body: JSON.stringify({ query: mutation })
        });
      })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        var co = data.data && data.data.checkoutCreate && data.data.checkoutCreate.checkout;
        if (!co) throw new Error('No checkout');

        var checkoutId  = co.id;
        var webUrl      = co.webUrl;
        var rates       = co.availableShippingRates;

        /* Si las tarifas ya están listas → aplicar y redirigir */
        if (rates && rates.ready && rates.shippingRates && rates.shippingRates.length) {
          return CartDrawer.applyShippingAndRedirect(checkoutId, rates.shippingRates[0].handle, webUrl, sfToken, store);
        }

        /* Si no están listas → esperar máx 5s y reintentar */
        return CartDrawer.pollShippingRates(checkoutId, webUrl, sfToken, store, 0);
      })
      .catch(function(err) {
        console.warn('Storefront checkout error:', err);
        /* fallback silencioso a /checkout */
        window.location.href = '/checkout';
      });
  },

  pollShippingRates: function(checkoutId, webUrl, sfToken, store, attempts) {
    if (attempts >= 5) {
      /* después de 5 intentos → redirigir de todas formas al webUrl */
      window.location.href = webUrl;
      return;
    }
    var query = `{
      node(id: "${checkoutId}") {
        ... on Checkout {
          availableShippingRates { ready shippingRates { handle title } }
          webUrl
        }
      }
    }`;
    setTimeout(function() {
      fetch('https://' + store + '/api/2024-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': sfToken
        },
        body: JSON.stringify({ query: query })
      })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        var node  = data.data && data.data.node;
        var rates = node && node.availableShippingRates;
        if (rates && rates.ready && rates.shippingRates && rates.shippingRates.length) {
          CartDrawer.applyShippingAndRedirect(checkoutId, rates.shippingRates[0].handle, node.webUrl || webUrl, sfToken, store);
        } else {
          CartDrawer.pollShippingRates(checkoutId, webUrl, sfToken, store, attempts + 1);
        }
      })
      .catch(function(){ window.location.href = webUrl; });
    }, 1000);
  },

  applyShippingAndRedirect: function(checkoutId, shippingHandle, webUrl, sfToken, store) {
    var mutation = `
      mutation {
        checkoutShippingLineUpdate(
          checkoutId: "${checkoutId}",
          shippingRateHandle: "${shippingHandle}"
        ) {
          checkout { webUrl }
          checkoutUserErrors { message }
        }
      }`;
    return fetch('https://' + store + '/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': sfToken
      },
      body: JSON.stringify({ query: mutation })
    })
    .then(function(r){ return r.json(); })
    .then(function(data) {
      var co = data.data && data.data.checkoutShippingLineUpdate && data.data.checkoutShippingLineUpdate.checkout;
      window.location.href = (co && co.webUrl) || webUrl;
    })
    .catch(function(){ window.location.href = webUrl; });
  },

  /* ── Barra de envío gratis ──────────────────────────────────── */
  renderShippingBar: function (totalCents, itemCount) {
    var bar = this.shippingBar;
    if (!bar) return;
    if (itemCount === 0) {
      bar.innerHTML = '';
      bar.classList.remove('is-visible');
      return;
    }
    bar.classList.add('is-visible');
    var remaining = Math.max(0, FREE_SHIPPING_THRESHOLD - totalCents);
    var pct = Math.min(100, Math.round(totalCents / FREE_SHIPPING_THRESHOLD * 100));
    if (remaining === 0) {
      bar.innerHTML =
        '<div class="csb-msg csb-msg--done">' +
          '<span class="csb-emoji">🎉</span>' +
          '¡Tienes <strong>envío gratis</strong>! <span class="csb-emoji">🚚</span>' +
        '</div>' +
        '<div class="csb-track"><div class="csb-fill" style="width:100%"></div></div>';
    } else {
      bar.innerHTML =
        '<div class="csb-msg">' +
          '<span class="csb-emoji">🚚</span>' +
          'Te faltan <strong>' + fmt(remaining) + '</strong> para <strong>envío gratis</strong>' +
        '</div>' +
        '<div class="csb-track"><div class="csb-fill" style="width:' + pct + '%"></div></div>';
    }
  },

  /* ── Sección "También te puede interesar" ───────────────────── */
  fetchUpsell: function (cartProductIds) {
    var el = this.upsellEl;
    if (!el) return;
    /* Mostrar solo bufandas, rebozos, cinturones o accesorios para celular
       con precio entre $300 y $800 MXN — nunca bolsas ni maletines */
    var collections = [
      '/collections/bufandas/products.json?limit=8',
      '/collections/rebozos/products.json?limit=6',
      '/collections/cinturones/products.json?limit=4',
      '/collections/carcasas/products.json?limit=4'
    ];
    Promise.all(collections.map(function (url) {
      return fetch(url).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; });
    })).then(function (results) {
      var MIN_CENTS = 30000, MAX_CENTS = 80000;
      var all = [];
      results.forEach(function (data) { all = all.concat(data.products || []); });
      /* Deduplicar por id */
      var seen = {};
      all = all.filter(function (p) {
        if (seen[p.id]) return false;
        seen[p.id] = true;
        return true;
      });
      var candidates = all.filter(function (p) {
        if (!p.variants || !p.variants.length) return false;
        var cents = Math.round(parseFloat(p.variants[0].price) * 100);
        return cents >= MIN_CENTS && cents <= MAX_CENTS && cartProductIds.indexOf(p.id) === -1;
      });
      /* Mezclar aleatoriamente */
      for (var i = candidates.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = candidates[i]; candidates[i] = candidates[j]; candidates[j] = tmp;
      }
      CartDrawer.renderUpsell(candidates.slice(0, 3), el);
    });
  },

  renderUpsell: function (products, el) {
    if (!products || !products.length) { el.innerHTML = ''; return; }
    var html =
      '<div class="cu-wrap">' +
        '<h3 class="cu-title">También te puede interesar</h3>' +
        '<ul class="cu-list">';
    products.forEach(function (p) {
      var imgSrc = (p.images && p.images.length)
        ? p.images[0].src.split('?')[0] + '?width=160'
        : '';
      var priceCents = Math.round(parseFloat(p.variants[0].price) * 100);
      html +=
        '<li class="cu-item">' +
          (imgSrc
            ? '<a href="/products/' + p.handle + '" class="cu-img-link" onclick="CartDrawer.close()">' +
                '<img src="' + imgSrc + '" alt="' + p.title + '" class="cu-img" loading="lazy">' +
              '</a>'
            : '<div class="cu-img cu-img--empty"></div>') +
          '<div class="cu-body">' +
            '<p class="cu-name">' + p.title + '</p>' +
            '<p class="cu-price">' + fmt(priceCents) + '</p>' +
          '</div>' +
          '<button class="cu-add" data-variant="' + p.variants[0].id + '" aria-label="Agregar al carrito">+</button>' +
        '</li>';
    });
    html += '</ul></div>';
    el.innerHTML = html;

    el.querySelectorAll('.cu-add').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var vid = parseInt(btn.dataset.variant, 10);
        btn.disabled = true;
        btn.classList.add('cu-add--loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1 })
        }).then(function () {
          btn.classList.remove('cu-add--loading');
          btn.classList.add('cu-add--done');
          btn.textContent = '✓';
          CartDrawer.fetch();
          CartDrawer.refreshBadge();
        }).catch(function () {
          btn.disabled = false;
          btn.classList.remove('cu-add--loading');
          btn.textContent = '+';
        });
      });
    });
  },

  changeQty: function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () {
      CartDrawer.fetch();
      CartDrawer.refreshBadge();
    });
  },

  refreshBadge: function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.cart-badge');
        badges.forEach(function (b) {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      });
  }
};

/* ══════════════════════════════════════════════════════════════
   WISHLIST  (localStorage)
══════════════════════════════════════════════════════════════ */
var Wishlist = {
  KEY: 'ciprian_wishlist_v1',

  get: function () {
    try { return JSON.parse(localStorage.getItem(this.KEY)) || []; }
    catch (e) { return []; }
  },

  save: function (items) {
    localStorage.setItem(this.KEY, JSON.stringify(items));
  },

  toggle: function (product) {
    var items = this.get();
    var idx = items.findIndex(function (i) { return String(i.id) === String(product.id); });
    if (idx > -1) {
      items.splice(idx, 1);
      this.save(items);
      return false; // removed
    } else {
      items.push(product);
      this.save(items);
      return true; // added
    }
  },

  has: function (id) {
    return this.get().some(function (i) { return String(i.id) === String(id); });
  },

  updateBadge: function () {
    var count = this.get().length;
    var badges = document.querySelectorAll('.wishlist-badge');
    badges.forEach(function (b) {
      b.textContent = count;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  bindBtn: function (btn) {
    var self = this;
    var id = btn.dataset.productId;
    if (self.has(id)) btn.classList.add('is-active');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var product = {
        id:    btn.dataset.productId,
        title: btn.dataset.productTitle,
        price: btn.dataset.productPrice,
        image: btn.dataset.productImage,
        url:   btn.dataset.productUrl
      };
      var added = self.toggle(product);
      btn.classList.toggle('is-active', added);
      self.updateBadge();

      /* micro toast */
      var msg = added ? '❤️  Agregado a favoritos' : 'Eliminado de favoritos';
      self.toast(msg);
    });
  },

  toast: function (msg) {
    var t = document.createElement('div');
    t.className = 'wishlist-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('show'); }, 10);
    setTimeout(function () {
      t.classList.remove('show');
      setTimeout(function () { t.remove(); }, 300);
    }, 2200);
  },

  init: function () {
    var self = this;
    self.updateBadge();

    document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      self.bindBtn(btn);
    });

    /* render favorites page if present */
    var grid = document.getElementById('favoritesGrid');
    if (grid) self.renderFavorites(grid);
  },

  renderFavorites: function (container) {
    var self = this;
    var items = self.get();

    if (!items.length) {
      container.innerHTML =
        '<div class="favorites-empty">' +
          '<p>Aún no tienes productos guardados.</p>' +
          '<a href="/collections/all" class="btn-atc">Ver productos</a>' +
        '</div>';
      return;
    }

    var html = '<div class="products-grid">';
    items.forEach(function (p) {
      html +=
        '<div class="product-card">' +
          '<a href="' + p.url + '">' +
            '<div class="product-img-wrap">' +
              '<img src="' + p.image + '" alt="' + p.title + '" class="product-img" loading="lazy">' +
            '</div>' +
            '<div class="product-info">' +
              '<p class="product-name">' + p.title + '</p>' +
              '<div class="product-pricing">' +
                '<span class="product-price">' + p.price + '</span>' +
              '</div>' +
            '</div>' +
          '</a>' +
          '<button class="wishlist-btn is-active"' +
            ' data-product-id="' + p.id + '"' +
            ' data-product-title="' + p.title + '"' +
            ' data-product-price="' + p.price + '"' +
            ' data-product-image="' + p.image + '"' +
            ' data-product-url="' + p.url + '"' +
            ' aria-label="Quitar de favoritos">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18"><path d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/></svg>' +
          '</button>' +
        '</div>';
    });
    html += '</div>';
    container.innerHTML = html;

    /* re-bind buttons inside favorites */
    container.querySelectorAll('.wishlist-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var product = {
          id:    btn.dataset.productId,
          title: btn.dataset.productTitle,
          price: btn.dataset.productPrice,
          image: btn.dataset.productImage,
          url:   btn.dataset.productUrl
        };
        self.toggle(product);
        self.updateBadge();
        self.renderFavorites(container);
      });
    });
  }
};

/* ══════════════════════════════════════════════════════════════
   ACCOUNT DROPDOWN
══════════════════════════════════════════════════════════════ */
var AccountDropdown = {
  init: function () {
    var wrapper = document.getElementById('accountDropdown');
    if (!wrapper) return;
    var toggle = wrapper.querySelector('.account-toggle');
    var menu   = wrapper.querySelector('.account-menu');
    if (!toggle || !menu) return;

    /* En móvil: navegar directamente en vez de mostrar dropdown */
    toggle.addEventListener('click', function (e) {
      if (window.innerWidth <= 768) {
        /* Detectar si hay sesión activa por si hay link "Mi cuenta" */
        var accountLink = menu.querySelector('a[href="/account"]');
        if (accountLink) {
          window.location.href = '/account';
        } else {
          window.location.href = '/account/login';
        }
        return;
      }
      e.stopPropagation();
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });

    document.addEventListener('click', function () {
      if (window.innerWidth > 768) {
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
};

/* ══════════════════════════════════════════════════════════════
   CART PROMOS — 3 tipos de bundle (3×2 100ml / 4×3 60ml / 4×3 30ml)
   ══════════════════════════════════════════════════════════════ */
var CartPromos = {

  /* Definición de promos — ajusta aquí si cambian las reglas */
  PROMOS: [
    { key: 'p100', label: '3×2',  detail: '100 ml', regex: /100\s*ml/i, need: 3 },
    { key: 'p60',  label: '4×3',  detail: '60 ml',  regex: /60\s*ml/i,  need: 4 },
    { key: 'p30',  label: '4×3',  detail: '30 ml',  regex: /30\s*ml/i,  need: 4 }
  ],

  activeIdx: 0,
  el: null,
  lastCart: null,

  init: function () {
    this.el = document.getElementById('cartPromos');
  },

  /* Detecta el tamaño (ml) de un item del carrito */
  getSizeKey: function (item) {
    var text = [
      item.variant_title  || '',
      item.product_title  || '',
      item.sku            || ''
    ].join(' ').toLowerCase();
    for (var i = 0; i < this.PROMOS.length; i++) {
      if (this.PROMOS[i].regex.test(text)) return this.PROMOS[i].key;
    }
    return null;
  },

  render: function (cart) {
    if (!this.el) return;
    this.lastCart = cart;

    /* Contar items por tamaño */
    var counts = { p100: 0, p60: 0, p30: 0 };
    var self = this;
    (cart.items || []).forEach(function (item) {
      var key = self.getSizeKey(item);
      if (key) counts[key] += item.quantity;
    });

    /* Si no hay ningún item con talla ml conocida, ocultar sección */
    var total = counts.p100 + counts.p60 + counts.p30;
    if (total === 0) { this.el.style.display = 'none'; return; }

    /* Auto-selecciona el tab de la promo más cercana a cumplirse */
    var idx = this.activeIdx;
    /* Si la activa ya está desbloqueada, mueve al siguiente sin desbloquear */
    if (counts[this.PROMOS[idx].key] >= this.PROMOS[idx].need) {
      for (var j = 0; j < this.PROMOS.length; j++) {
        if (counts[this.PROMOS[j].key] < this.PROMOS[j].need) { idx = j; break; }
      }
    }

    /* ── Tabs ── */
    var html = '<div class="cp-header">🔥 Promociones especiales</div>';
    html += '<div class="cp-tabs">';
    this.PROMOS.forEach(function (p, i) {
      var c       = counts[p.key];
      var done    = c >= p.need;
      var isActive = i === self.activeIdx;
      html +=
        '<button class="cp-tab' + (isActive ? ' cp-tab--active' : '') + (done ? ' cp-tab--done' : '') + '" data-idx="' + i + '">' +
          '<span class="cp-tab-status">' + (done ? '✓' : (p.need - c)) + '</span>' +
          '<span class="cp-tab-name">' + p.label + '</span>' +
          '<span class="cp-tab-size">' + p.detail + '</span>' +
        '</button>';
    });
    html += '</div>';

    /* ── Barra de progreso del tab activo ── */
    var active  = this.PROMOS[this.activeIdx];
    var count   = counts[active.key];
    var done    = count >= active.need;
    var pct     = Math.min(100, Math.round(count / active.need * 100));

    html += '<div class="cp-progress-wrap">';
    if (done) {
      html += '<p class="cp-msg cp-msg--done">🎉 ¡<strong>' + active.label + '</strong> de ' + active.detail + ' desbloqueado! El descuento se aplica al pagar.</p>';
    } else {
      var left = active.need - count;
      html += '<p class="cp-msg">Agrega <strong>' + left + '</strong> perfume(s) de ' + active.detail + ' para <strong>' + active.label + '</strong> 🔥</p>';
    }
    html += '<div class="cp-bar"><div class="cp-bar-fill" style="width:' + pct + '%"></div></div>';
    html += '</div>';

    this.el.innerHTML = html;
    this.el.style.display = '';

    /* Bind clicks en tabs */
    var self2 = this;
    this.el.querySelectorAll('.cp-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self2.activeIdx = parseInt(btn.dataset.idx, 10);
        self2.render(self2.lastCart);
      });
    });
  }
};

/* ── Init on DOM ready ───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  CartDrawer.init();
  CartPromos.init();
  Wishlist.init();
  AccountDropdown.init();
});

/* ── Also refresh cart badge on page load ───────────────────── */
document.addEventListener('DOMContentLoaded', function () {
  CartDrawer.refreshBadge();
});

/* ── Promo Banners con Countdown 24h renovable ── */
(function () {
  /* Fechas de expiración total (hora CDMX = UTC-5) */
  var END_HOT    = new Date('2026-06-03T00:00:00-05:00').getTime();
  var END_SUMMER = new Date('2026-08-04T00:00:00-05:00').getTime();

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* Próxima medianoche en hora local del navegador */
  function nextMidnight() {
    var d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  }

  /* Countdown de 24 h que se reinicia solo a medianoche */
  function start24hCountdown(ids, hardEnd) {
    var deadline = nextMidnight();

    function tick() {
      var now  = Date.now();

      /* Si ya pasó la fecha de expiración total, oculta todo */
      if (now >= hardEnd) {
        clearInterval(t);
        var banner = document.getElementById(ids[4]);
        if (banner) banner.style.display = 'none';
        return;
      }

      /* Si pasó la medianoche, recalcula la próxima */
      if (now >= deadline) deadline = nextMidnight();

      var diff  = deadline - now;
      /* En un countdown de 24h no mostramos "días", siempre 00 */
      document.getElementById(ids[0]).textContent = '00';
      document.getElementById(ids[1]).textContent = pad(Math.floor(diff / 3600000));
      document.getElementById(ids[2]).textContent = pad(Math.floor((diff % 3600000) / 60000));
      document.getElementById(ids[3]).textContent = pad(Math.floor((diff % 60000)   / 1000));
    }

    tick();
    var t = setInterval(tick, 1000);
  }

  var now = Date.now();

  /* ── HOT SALE: activo hasta el 2 de junio ── */
  if (now < END_HOT) {
    var bHot = document.getElementById('promoBannerHot');
    if (bHot) {
      bHot.style.display = '';
      start24hCountdown(
        ['pbcDays', 'pbcHours', 'pbcMins', 'pbcSecs', 'promoBannerHot'],
        END_HOT
      );
    }
    return;
  }

  /* ── VERANO: activo del 3 de junio al 3 de agosto ── */
  if (now < END_SUMMER) {
    var bSummer = document.getElementById('promoBannerSummer');
    if (bSummer) {
      bSummer.style.display = '';
      start24hCountdown(
        ['pbcSDays', 'pbcSHours', 'pbcSMins', 'pbcSSecs', 'promoBannerSummer'],
        END_SUMMER
      );
    }
    return;
  }

  /* ── Después del 3 de agosto: ningún banner ── */
})();
